// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b635f976","239":"d99803fe","312":"02d4c6f3","455":"774554e3"}[chunkId] + ".chunk.js";
};